import axios from "axios";
import qs from "qs";

import {
  mutations as LoginUserMutations,
  store as LoginUserStore
} from "../store/LoginUser";
import { mutations } from "../store/Bootstrap";

const CancelToken = axios.CancelToken;
let cancel = null;

const AsteriaApi = {
  // via: https://qiita.com/amamamaou/items/ef0b797156b324bb4ef3#objectprototypetostringcall-%E3%82%92%E4%BD%BF%E3%81%86
  typeof(obj) {
    return Object.prototype.toString
      .call(obj)
      .slice(8, -1)
      .toLowerCase();
  },

  /**
   * Convert null to empty string
   *
   * @param any
   * @return any
   */
  convertRequest(convertData) {
    if (convertData === null) {
      convertData = "";
    } else if (convertData === true || convertData === false) {
      convertData = convertData ? 1 : 0;
    } else if (this.typeof(convertData) === "number") {
      convertData = convertData.toString();
    } else if (this.typeof(convertData) === "array") {
      convertData.forEach((_, k) => {
        convertData[k] = this.convertRequest(convertData[k]);
      });
    } else if (this.typeof(convertData) === "object") {
      Object.keys(convertData).forEach(k => {
        convertData[k] = this.convertRequest(convertData[k]);
      });
    }

    return convertData;
  },

  /**
   * Convert string number to actual number
   *
   * @param any
   * @return any
   */
  convertReponse(convertData) {
    if (typeof convertData === "string") {
      convertData = convertData.trim();
      if (convertData.length === 1) {
        const converted = parseInt(convertData, 10);
        if (convertData === converted.toString()) {
          convertData = converted;
        }
      }
    } else if (this.typeof(convertData) === "array") {
      convertData.forEach((_, k) => {
        convertData[k] = this.convertReponse(convertData[k]);
      });
    } else if (this.typeof(convertData) === "object") {
      Object.keys(convertData).forEach(k => {
        convertData[k] = this.convertReponse(convertData[k]);
      });
    }

    return convertData;
  },

  /**
   * @param {apiUrl: string} options
   */
  install(Vue, options) {
    const apiUrl = options.apiUrl;
    const submitUrl = options.submitUrl;
    const loginUrl = options.loginUrl;
    const loginNittoUrl = options.loginNittoUrl;
    const loginShiiresakiUrl = options.loginShiiresakiUrl;

    const getStaticUrl = url => {
      return (
        process.env.VUE_APP_PUBLIC_PATH + "/" + url.replace(/^[/|.]*\/?/, "")
      );
    };
    Vue.prototype.getStaticUrl = getStaticUrl;

    /**
     * Redirect to Login page
     */
    const linkToLogin = () => {
      switch (LoginUserStore.info.login_url_di) {
        case 2:
          window.location.href = loginNittoUrl;
          break;
        case 3:
            window.location.href = loginShiiresakiUrl;
            break;
        default:
          window.location.href = loginUrl;
          break;
      }
      // submitAsteria("", "", {}, "", "/");
    };
    Vue.prototype.linkToLogin = linkToLogin;

    const redirectToLogin = () => {
      //console.log("Fatal Error, redirect to Login page");
      LoginUserMutations.setError(
        "セッションの有効期限が切れました。ログイン画面へお戻りください。"
      );

      // window.location.href = loginUrl;
      // submitAsteria("", "", {}, "", "/");
    };
    Vue.prototype.redirectToLogin = redirectToLogin;

    /**
     * Post data to ASTERIA
     */
    const postAsteria = async (
      xSid,
      xSno,
      apiParameters,
      withoutLoading = false
    ) => {
      if (cancel !== null) {
        cancel.cancel();
        cancel = null;
      }

      if (!withoutLoading) {
        mutations.showLoading();
      }

      // Prepare posting data
      const params = qs.stringify({
        xSid,
        xSno,
        apiParameters: JSON.stringify(this.convertRequest(apiParameters))
      });

      // Send data to ASTERIA
      cancel = CancelToken.source();
      const res = await axios
        .post(apiUrl, params, {
          responseData: "json",
          withCredentials: process.env.VUE_APP_COOKIE_FLAG === "true",
          cancelToken: cancel.token
        })
        .catch(e => {
          if (axios.isCancel(e)) {
            cancel = null;
            //console.log("通信はキャンセルされました");
          } else {
            //console.log(e);
            window.alert(
              "サーバエラーが発生しました、管理者の方にご連絡ください"
            );
            mutations.hideLoading();

            // LoginUserMutations.setError(
            //   "エラーが発生しました。ログイン画面へお戻りください。"
            // );
            cancel = null;
            throw e;
          }
        });
      cancel = null;
      if (!withoutLoading) {
        mutations.hideLoading();
      }

      if (!res) {
        throw new Error();
      }

      // Over 400 response is error
      // Status 400以上 は エラーレスポンス
      if (res.status >= 400) {
        window.alert("サーバエラーが発生しました、管理者の方にご連絡ください");
        // LoginUserMutations.setError(
        //   "エラーが発生しました。ログイン画面へお戻りください。"
        // );
        throw res;
      }

      if (typeof res.data === "string") {
        try {
          res.data = JSON.parse(res.data);
        } catch (e) {
          //console.log(res.data);
          window.alert("不正な値が返却されました、管理者の方にご連絡ください");
          // LoginUserMutations.setError(
          //   "エラーが発生しました。ログイン画面へお戻りください。"
          // );
          throw e;
        }
      }

      if (res.data.hasOwnProperty("responseData")) {
        res.data.responseData = this.convertReponse(res.data.responseData);

        if (res.data.responseData.return == 9) {
          window.alert(
            "セッションエラーが発生しました。\nログアウト後、再度ログインしてください。"
          );
          // return redirectToLogin();
        }
      }

      return res.data;
    };
    Vue.prototype.postAsteria = postAsteria;

    let beforeHook = null;
    const addHookBeforeSubmitAsteria = callback => {
      beforeHook = callback;
    };
    Vue.prototype.addHookBeforeSubmitAsteria = addHookBeforeSubmitAsteria;

    const getHookBeforeSubmitAsteria = () => {
      return beforeHook;
    };
    Vue.prototype.getHookBeforeSubmitAsteria = getHookBeforeSubmitAsteria;

    /**
     * Submit data to ASTERIA
     */
    const submitAsteria = async (
      xSid,
      xSno,
      apiParameters,
      flagment,
      fallBack,
      submitForce = false
    ) => {
      if (beforeHook !== null && !submitForce) {
        if (!beforeHook()) {
          return;
        }
      }

      if (!submitUrl || submitUrl === "false") {
        window.location.href = getStaticUrl(fallBack);
        return;
      }

      // Preparing form tag
      const form = document.createElement("form");
      form.action = submitUrl + (flagment ? `#${flagment}` : "");
      form.method = "post";
      form.style.display = "none";

      // Preparing input tags
      const xSidInput = document.createElement("input");
      xSidInput.value = xSid;
      xSidInput.name = "xSid";
      form.appendChild(xSidInput);

      const xSnoInput = document.createElement("input");
      xSnoInput.value = xSno;
      xSnoInput.name = "xSno";
      form.appendChild(xSnoInput);

      const paramterInput = document.createElement("input");
      paramterInput.value = JSON.stringify(this.convertRequest(apiParameters));
      paramterInput.name = "apiParameters";
      form.appendChild(paramterInput);

      document.body.appendChild(form);
      form.submit();
    };
    Vue.prototype.submitAsteria = submitAsteria;

    /**
     * Submit data to ASTERIA (New Tab)
     */
    const submitNewTabAsteria = async (
      xSid,
      xSno,
      apiParameters,
      flagment,
      fallBack
    ) => {
      if (!submitUrl || submitUrl === "false") {
        // window.location.href = getStaticUrl(fallBack);
        window.open(getStaticUrl(fallBack), "_blank");
        return;
      }

      // Preparing form tag
      const form = document.createElement("form");
      form.action = submitUrl + (flagment ? `#${flagment}` : "");
      form.method = "post";
      form.target = "_blank";
      form.style.display = "none";

      // Preparing input tags
      const xSidInput = document.createElement("input");
      xSidInput.value = xSid;
      xSidInput.name = "xSid";
      form.appendChild(xSidInput);

      const xSnoInput = document.createElement("input");
      xSnoInput.value = xSno;
      xSnoInput.name = "xSno";
      form.appendChild(xSnoInput);

      const paramterInput = document.createElement("input");
      paramterInput.value = JSON.stringify(this.convertRequest(apiParameters));
      paramterInput.name = "apiParameters";
      form.appendChild(paramterInput);

      document.body.appendChild(form);
      form.submit();
    };
    Vue.prototype.submitNewTabAsteria = submitNewTabAsteria;

    /**
     * Get Response Data from Array or Object
     *
     * * Missing -> return Empty array
     * * Object -> return Array<Object>
     * * Array -> return Array
     */
    const getAsteriaArray = (responseData, key) => {
      if (!responseData.hasOwnProperty(key)) {
        return [];
      }

      if (Array.isArray(responseData[key])) {
        return responseData[key];
      } else {
        return [responseData[key]];
      }
    };
    Vue.prototype.getAsteriaArray = getAsteriaArray;

    /**
     * Get First data of Response Data
     *
     * * Missing -> return null
     */
    const getAsteriaFirst = (responseData, key) => {
      const data = getAsteriaArray(responseData, key);

      if (!data.length) {
        return {};
      }
      return data[0];
    };
    Vue.prototype.getAsteriaFirst = getAsteriaFirst;
  }
};

export default AsteriaApi;
